module.exports = __webpack_public_path__ + "img/2_icon_contraception.e14dc242.png";